import React from 'react'
import { Box, Typography, Paper, ButtonBase, IconButton, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import GroupIcon from '@mui/icons-material/Group';
import Favorite from '@mui/icons-material/Favorite';
import PlaceIcon from '@mui/icons-material/Place';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import SvgIcon from '@mui/material/SvgIcon';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BACKGROUND_COLOR, ICON_COLOR, ICON_DARK_GRAY, TEXT_DARK_GRAY, UNDERLINE_ACCENT_COLOR, UNDERLINE_DARK_COLOR } from '../colorPalette';
import GroupHeartItem from './GroupHeartItem';

function GroupContainer({customStyles, groupName, numberMembers, onClick, numberHearts, colorMode, groupHearts, hearts, group}) {


    return (
        // relative ensures absolute positioning of elements within the Paper is relative to the Paper
        <Paper style={{paddingTop: '20px', paddingLeft: '20px', paddingRight: '20px', textAlign: 'center', backgroundColor: BACKGROUND_COLOR, position: 'relative'}}>
        
            <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="h6" fontSize="18px" fontWeight="500">
                    {groupName}
                </Typography>
            </Box>
            <IconButton onClick={onClick} sx={{ 
                position: 'absolute', 
                top: '10px', 
                right: '10px', 
                color: ICON_COLOR
            }}>
                <SettingsIcon />
            </IconButton>
            

            {/* If no hearts in group, show empty message */}
            {group.hearts.length === 0 && (
                    <Box sx={{textAlign: 'center', alignSelf: 'center', marginTop: '10px'}}>
                        <Typography variant={'body2'} fontSize={'11px'} fontStyle={'italic'}>No hearts in this group. Click 'Add to Group' below a heart to add it to this group.</Typography>
                    </Box>
                )
            }
            {group.hearts.length > 0 && (
                <Box sx={{alignContent: 'center', width: '100%'}}>
                    <Typography variant={'body2'} fontSize={'12px'} fontStyle={'italic'} sx={{textAlign: 'left', color: TEXT_DARK_GRAY}}>Hearts</Typography>
                </Box>
            )}
            {group.hearts.map((heartID, index) => {
                // Find the heart object in the hearts or groupHearts array that matches the heart id
                const heart = groupHearts.find(heart => heart.id === group.hearts[index]) || hearts.find(heart => heart.id === group.hearts[index]);
                if (!heart) {
                    console.log("Heart not found. GroupHearts likely not ready yet. Returning null.")
                    return null;
                }

                return (
                    <Box key={index} sx={{display: 'flex', flexDirection: 'column', marginTop: '5px'}}>
                        <GroupHeartItem heart={heart} group={group} index={index} />
                    </Box>
                )
            })}
            {/* Accordion to list the group's members */}
            <Box sx={{ paddingTop: '5px', width: '100%', display: 'flex', justifyContent: 'center'}}>
                <Accordion sx={{padding: '0px', width: '100%', backgroundColor: BACKGROUND_COLOR}} disableGutters elevation={0}>
                    <AccordionSummary sx={{padding: '0px'}} expandIcon={ <ExpandMoreIcon /> }>
                        <Typography variant={'body2'} fontSize={'12px'} fontStyle={'italic'} sx={{textAlign: 'left', color: TEXT_DARK_GRAY}}>Members</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{padding: '0px', paddingBottom: '10px'}}>
                        {/* List the group's members */}
                        {group !== undefined && group.members.map((member, index) => (
                            // TODO: Update this to display the member's display name
                            <Box key={index} sx={{display: 'flex', alignItems: 'center'}}>
                                <PersonIcon sx={{fontSize:'24px', color: ICON_COLOR}}/>
                                <Typography sx={{marginLeft: '5px'}}  variant='body2' fontSize={'12px'}>{member.email}</Typography>
                            </Box>
                        ))}
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Paper>
    )
}

export default GroupContainer